import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Gallery from './pages/Gallery/Gallery';
import Achivement from './pages/Achivement/Achivement';
import Contact from './pages/Contact/Contact';
import TheBeginnerCourse from './pages/Courses/TheBeginnerCourse';
import TheIntermediateCourse from './pages/Courses/TheIntermediateCourse';
import TheAdvancedCourse from './pages/Courses/TheAdvancedCourse';
import Header from './pages/Header/Header';
import Footer from './Footer/Footer';

function App() {
    return (
        <Router>
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/achivement" element={<Achivement />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/thebeginnercourse" element={<TheBeginnerCourse />} />
                <Route path="/theintermediatecourse" element={<TheIntermediateCourse />} />
                <Route path="/theadvancedcourse" element={<TheAdvancedCourse />} />
            </Routes>
            <Footer />
        </Router>
    );
}

export default App;
